import { positions } from 'react-alert';

export const alertOptions = {
  timeout: 3000,
  position: positions.BOTTOM_RIGHT
};
